// extracted by mini-css-extract-plugin
export default {"entireWindow":"Modal_entireWindow__gI2Qa","backdrop":"Modal_backdrop__Ovtnz","modal":"Modal_modal__ZjBx1","button":"Modal_button__A80GA"};